import React from 'react';
import AccordionItem from '@components/Faq/accordionItem';
import { Text } from '@ui/atoms';
import { faqsHome } from '@components/Faq/utils/helper';

const FaqsHome = () => {
    return (
        <div className="max-width-wrapper px-4 py-10 md:pt-18 md:pb-2 md:px-16 flex flex-col">
            <div className=" flex flex-col gap-10 w-full ">
                <Text
                    className="text-primary-500 h3-semibold md:h2-semibold text-center"
                    content={'FAQs'}
                />

                {faqsHome.map((section, index) => (
                    <div key={index} className="w-full">
                        {section.questionBank.map((item, index) => (
                            <div key={index} className="mt-4">
                                <AccordionItem
                                    question={item.question}
                                    answer={item.answer}
                                    note={item.note}
                                />
                            </div>
                        ))}{' '}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FaqsHome;
